import styled from "styled-components";
import { COLORS } from "../../../../../../assets/constants/styles";

export const SourcesList = styled.ul`
  margin-top: 12px;
  padding-left: 20px;
  list-style-type: none;
`;

export const SourceItem = styled.li`
  margin-bottom: 10px;
  position: relative;
  padding-left: 5px;

  &:before {
    content: "•";
    color: ${COLORS.violet};
    font-size: 18px;
    position: absolute;
    left: -15px;
    top: -2px;
  }
`;

export const SourceLink = styled.a`
  color: ${COLORS.violet};
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
`;
